function buildFavourites() {
	const favourites = document.querySelectorAll( '.favorites-list__item' );
	let favouriteTitles = [];

	for ( let i = 0; i < favourites.length; i++ ) {
		let title = favourites[i].getAttribute( 'data-title' );

		favouriteTitles.push( title );
	}

	return favouriteTitles.join('|');
};

// Add favourites list items to hidden input.
document.addEventListener( 'click', function(event) {
	if ( event.target.id !== 'favourites-enquiry' ) return;
	document.querySelector( '#field_uu2ev' ).value = buildFavourites();
});
